import provincecityarea from '@/components/formcomponents/common/select/provincecityarea/select.vue'
import warehouse from '@/components/formcomponents/common/select/warehouse/select.vue'
import relatedcompany from '@/components/formcomponents/common/select/relatedcompany/select.vue'
import company from '@/components/formcomponents/common/select/company/select.vue'
import bankaccount from '@/components/formcomponents/common/select/bankaccount/select.vue'
import supplier from '@/components/formcomponents/common/select/supplier/select.vue'
import invoicetype from '@/components/formcomponents/common/select/invoicetype/select.vue'
import parcel from '@/components/formcomponents/common/select/parcel/select.vue'
import tableInvoicematch from '@/components/formcomponents/common/table/invoicematch/index.vue'
import map from '@/components/formcomponents/common/map/index.vue'



const components = [{
	name: 'provincecityarea',
	component: provincecityarea,
	onlyEl: true
}, {
	name: 'warehouse',
	component: warehouse,
	onlyEl: false
}, {
	name: 'relatedcompany',
	component: relatedcompany,
	onlyEl: false
}, {
	name: 'supplier',
	component: supplier,
	onlyEl: false
}, {
	name: 'company',
	component: company,
	onlyEl: false
}, {
	name: 'bankaccount',
	component: bankaccount,
	onlyEl: false
}, {
	name: 'invoicetype',
	component: invoicetype,
	onlyEl: false
}, {
	name: 'parcel',
	component: parcel,
	onlyEl: false
}, {
	name: 'map',
	component: map,
	onlyEl: true
}, {
	name: 'tableInvoicematch',
	component: tableInvoicematch,
	onlyEl: true
}]
export default {
	components: components
}
